declare global {
  interface Window {
    dataLayer: Record<string, unknown>[];
  }
}

export type GTMEvent =
  | 'page_view_offer'
  | 'page_view_report'
  | 'page_view_bodyboost'
  | 'scroll_50_offer'
  | 'scroll_90_offer'
  | 'scroll_50_report'
  | 'scroll_90_report'
  | 'scroll_50_bodyboost'
  | 'scroll_90_bodyboost'
  | 'initiate_checkout'
  | 'click_to_offer_from_report'
  | 'click_to_offer_from_bodyboost'
  | 'video_play_offer'
  | 'purchase_completed';

export const pushToDataLayer = (event: GTMEvent): void => {
  if (typeof window !== 'undefined' && window.dataLayer) {
    window.dataLayer.push({ event });

    if (import.meta.env.DEV) {
      console.log(`[GTM Event] ${event}`);
    }
  }
};

export const getSessionStorage = (key: string): string | null => {
  if (typeof window !== 'undefined' && window.sessionStorage) {
    return sessionStorage.getItem(key);
  }
  return null;
};

export const setSessionStorage = (key: string, value: string): void => {
  if (typeof window !== 'undefined' && window.sessionStorage) {
    sessionStorage.setItem(key, value);
  }
};

export const hasEventFiredThisSession = (eventKey: string): boolean => {
  return getSessionStorage(eventKey) === 'true';
};

export const markEventAsFired = (eventKey: string): void => {
  setSessionStorage(eventKey, 'true');
};
